<div class="admin-page-container">
  <div class="page-header">
    <div class="header-left">
      <h1>Scheme Management</h1>
      <p>Create and track development schemes for approval</p>
    </div>
    <div class="header-right">
      <button class="btn-primary" (click)="openCreateModal()">
        <i class="fa-solid fa-folder-plus"></i>
        <span>Create Scheme</span>
      </button>
    </div>
  </div>

  <div class="dashboard-stats-row">
    <div class="stat-card">
      <div class="stat-icon bg-blue"><i class="fa-solid fa-folder"></i></div>
      <div class="stat-info">
        <span class="label">My Schemes</span>
        <span class="value">{{ schemes().length }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-orange"><i class="fa-solid fa-clock"></i></div>
      <div class="stat-info">
        <span class="label">Pending</span>
        <span class="value">{{ pendingSchemes() }}</span>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon bg-green"><i class="fa-solid fa-circle-check"></i></div>
      <div class="stat-info">
        <span class="label">Approved</span>
        <span class="value">{{ approvedSchemes() }}</span>
      </div>
    </div>
  </div>

  <app-data-table
    [title]="'Scheme Registry'"
    [data]="schemes()"
    [columns]="columns"
    [loading]="loading()"
    (action)="handleTableAction($event)"
  ></app-data-table>
</div>

<!-- Create/Edit Scheme Modal -->
<app-admin-modal
  [isOpen]="isModalOpen()"
  [title]="editingScheme ? 'Edit Scheme' : 'Create Scheme'"
  [subtitle]="editingScheme ? 'Update scheme details for re-approval' : 'Submit a new scheme for review by an Approver'"
  [icon]="editingScheme ? 'fa-solid fa-folder-gear' : 'fa-solid fa-folder-plus'"
  [submitText]="editingScheme ? 'Update & Resubmit' : 'Submit for Approval'"
  [isSubmitting]="isSubmitting()"
  (close)="isModalOpen.set(false)"
  (submit)="submitForm()"
>
  <form [formGroup]="schemeForm" class="admin-form">
    <div class="form-grid">
      <div class="form-group">
        <label>Scheme Code</label>
        <div class="input-wrap">
          <i class="fa-solid fa-hashtag"></i>
          <input type="text" formControlName="code" placeholder="e.g. SCH-001">
        </div>
      </div>

      <div class="form-group">
        <label>Department</label>
        <div class="input-wrap">
          <i class="fa-solid fa-building"></i>
          <select formControlName="deptId">
            <option value="">Select Department</option>
            <option *ngFor="let dept of departments()" [value]="dept.id">{{ dept.name }}</option>
          </select>
        </div>
      </div>

      <div class="form-group full">
        <label>Scheme Name</label>
        <div class="input-wrap">
          <i class="fa-solid fa-heading"></i>
          <input type="text" formControlName="name" placeholder="Enter full scheme name">
        </div>
      </div>

      <div class="form-group full">
        <label>Description</label>
        <textarea formControlName="description" rows="3" placeholder="Scheme objectives and details..."></textarea>
      </div>

      <div class="form-group full">
        <label>Operator Remarks</label>
        <textarea formControlName="remarks" rows="2" placeholder="Any notes for the approver..."></textarea>
      </div>
    </div>
  </form>
</app-admin-modal>
